import { appConfig } from '../../../../config'
import { Consent, ConsentId, getConsentVersion } from './types'

export const postConsent = async ({
  consentId,
  accessToken,
}: {
  consentId: ConsentId
  accessToken: string
}): Promise<Response> => {
  const response = await fetch(`${appConfig.serverRootUrl}/api/private/consent`, {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({ consentId, version: getConsentVersion(consentId) }),
  })
  if (!response.ok) {
    const data = await response.json().catch(() => ({}))
    throw new Error(data?.message || `Failed to post consent ${consentId}`)
  }
  return response
}

export const getConsent = async ({
  consentId,
  accessToken,
}: {
  consentId: ConsentId
  accessToken: string
}): Promise<Consent> => {
  const response = await fetch(`${appConfig.serverRootUrl}/api/private/consent/${consentId}`, {
    method: 'GET',
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  })
  if (!response.ok) {
    const data = await response.json().catch(() => ({}))
    throw new Error(data?.message || `Failed to get consent ${consentId}`)
  }
  const data = await response.json()
  return data
}
